import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "py-3" }

import { onMounted, ref, Ref } from 'vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import Prog_circular    from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { FINAL_HEADERS_TABLE } from '@/constants/tableHeaders';
import { LABELS } from '@/constants/labels';

/********************************
 ********** INTERFACES **********
 *******************************/
import { STRINGS } from '@/interfaces/SmartLink/General';
import { PMPAP } from '@/interfaces/SmartLink/Graphs';
import { getStatusTable } from '@/services/Smartlink/Graphs';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
type BodyRowClassNameFunction = (item: STRINGS, rowIndex: number) => string;

/********************************
 *********** SERVICES ***********
 *******************************/

export default /*#__PURE__*/_defineComponent({
  __name: 'pmp-ap',
  props: {
    title   : { required:true },
    ip      : { required:true, type:String },
},
  setup(__props) {

const props = __props;

const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ********** COMPONENTS **********
 *******************************/
const store = useStore();

// Definir el tipo para la función de clases de fila




const arrayTable:Ref<PMPAP[]>       = ref([]);
const showTable                     = ref(true);

const params = { ip : props.ip }

/**
 * Captura los valores de la API: "getTableTopologyData"
 * envía como parámetro la IP
 */
async function getDataTable() {

    const allData = await getStatusTable(params)

    if( allData.status === 400 ){
        showTable.value = allData.showGraphs
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        showTable.value = allData.showGraphs
        arrayTable.value = allData.data
    }
}


const bodyRowClass : BodyRowClassNameFunction = (item:STRINGS):string =>{
    if(item.status.toUpperCase() === 'ALARM')  return 'alarm-design'
    if(item.status.toUpperCase() === 'ALERT')  return 'alert-design'
    return 'normal-design'
}


const header        = FINAL_HEADERS_TABLE['status'];
const finalHeader   = ref(header)

onMounted(() => {
    getDataTable();
})


return (_ctx: any,_cache: any) => {
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "mx-1 mt-8" }, {
    default: _withCtx(() => [
      (showTable.value)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            cols: "12",
            "align-self": "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, {
                class: _normalizeClass([_unref(xs)?'card-dialogs-graph-wop':'card-dialogs-graph', "mb-4 text-center card-container-table"]),
                color: "bgtopology"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h4", _hoisted_1, _toDisplayString(_unref(t)('title.tableTitle')), 1),
                  (arrayTable.value.length !== 0)
                    ? (_openBlock(), _createBlock(_component_v_sheet, {
                        key: 0,
                        height: "354",
                        color: "transparent",
                        class: "pt-10"
                      }, {
                        default: _withCtx(() => [
                          (arrayTable.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_EasyDataTable, {
                                key: 0,
                                "table-class-name": "customize-table",
                                "show-index": "",
                                headers: finalHeader.value,
                                items: arrayTable.value,
                                "rows-per-page": 10,
                                "body-row-class-name": bodyRowClass,
                                "hide-footer": ""
                              }, null, 8, ["headers", "items"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_sheet, {
                        key: 1,
                        class: "text-center",
                        color: "transparent"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Prog_circular)
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})